import {TeamMember} from '../../../services';
export const isMatch = (search: string = '', member: TeamMember): boolean => {
  const lcSearch = search.toLocaleLowerCase();

  return search === undefined || search === ''
    ? true
    : (member.firstName ?? '').toLocaleLowerCase().includes(lcSearch) ||
        (member.lastName ?? '').toLocaleLowerCase().includes(lcSearch) ||
        (member.mobileNo ?? '').toLocaleLowerCase().includes(lcSearch) ||
        member.personId.toString().includes(lcSearch);
};
